export enum LabourSheetStatusEnum {
    Empty = 0,
    Draft = 10,
    Pending = 20,
    Completed = 30,
    Closed = 40
}

export enum LabourSheetTypeEnum {
    Normal = 0,
    Incidental = 10
}

export enum ModeEnum {
    '' = 0,
    Add = 1,
    Edit = 2
}
